import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Building, Calendar } from "lucide-react";

interface BookingTypeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelectType: (type: "venue" | "event") => void;
}

export function BookingTypeDialog({
  open,
  onOpenChange,
  onSelectType,
}: BookingTypeDialogProps) {
  const handleSelect = (type: "venue" | "event") => {
    onSelectType(type);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Choose Booking Type</DialogTitle>
          <DialogDescription>
            How would you like to create your booking?
          </DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-1 gap-4 py-4">
          <Button
            onClick={() => handleSelect("venue")}
            variant="outline"
            className="h-auto p-4 sm:p-6 flex flex-col items-center gap-2 sm:gap-3 hover:bg-blue-50 hover:border-blue-300 transition-all"
          >
            <Building className="h-8 w-8 sm:h-10 sm:w-10 text-blue-600" />
            <div className="text-center space-y-1">
              <p className="font-semibold text-sm sm:text-base">Venue Booking</p>
              <p className="text-xs sm:text-sm text-slate-600 leading-relaxed whitespace-normal break-words">
                Book directly at a venue and automatically create a new event
              </p>
            </div>
          </Button>

          <Button
            onClick={() => handleSelect("event")}
            variant="outline"
            className="h-auto p-4 sm:p-6 flex flex-col items-center gap-2 sm:gap-3 hover:bg-green-50 hover:border-green-300 transition-all"
          >
            <Calendar className="h-8 w-8 sm:h-10 sm:w-10 text-green-600" />
            <div className="text-center space-y-1">
              <p className="font-semibold text-sm sm:text-base">Event Booking</p>
              <p className="text-xs sm:text-sm text-slate-600 leading-relaxed whitespace-normal break-words">
                Add a booking to an event that already exists
              </p>
            </div>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}